/** Amounts in a non-ISO operator currency go out in this unless the partner set an override. */
export const FALLBACK_CURRENCY = 'USD';

/** Events that happen before design_system answers wait at most this many. */
export const MAX_PENDING_EVENTS = 20;

export const META_SCRIPT_URL = 'https://connect.facebook.net/en_US/fbevents.js';
export const REDDIT_SCRIPT_URL = 'https://www.redditstatic.com/ads/pixel.js';
export const GTAG_SCRIPT_URL = 'https://www.googletagmanager.com/gtag/js';

/** Without these Chrome refuses gtag's cookies inside a cross-site iframe. */
export const GTAG_COOKIE_FLAGS = 'SameSite=None;Secure';
